module.exports = __webpack_public_path__ + "static/img/bg-ar.c782c688.webp";